﻿import * as eventTypes from '../../../map/utils/eventTypes';
export default class TimelineControl {
    constructor(action, resourcesHandler, layerSettingsHandler, menuContainer, rootURL, classId, mapControl, toolbarContainer) {
        this.action = action;
        this.resourcesHandler = resourcesHandler;
        this.layerSettingsHandler = layerSettingsHandler;
        this.menuContainer = menuContainer;
        this.rootURL = rootURL;
        this.classId = classId;
        this.mapControl = mapControl;
        this.map = mapControl.map;
        this.elementId = 'map-action-' + this.classId + '-' + this.action.Id;
        this.timelineRootId = 'timeline-root-' + this.classId + '-' + this.action.Id;
        this.toolbarContainer = toolbarContainer;
        this.active = false;
        this.config = {};
        this.currentSelection = {};
        if (this.action.Content != null && this.action.Content.trim() != '') {
            this.config = JSON.parse(this.action.Content);
        }
    }

    init() {
        this.menuContainer.append(this._getActionButtonTemplate());
        document.getElementById(this.elementId).addEventListener('click', this._actionButtonClickHandler());
        this._initTimeline();
    }

    _initTimeline() {
        const root = document.getElementById("map");

        let start = null;
        let end = null;

        if (this.config.intervalType) {
            start = this.config.start != null ? new Date(this.config.start) : null;
            end = this.config.end != null ? new Date(this.config.end) : null;
        } else {
            let currDate = new Date();
            if (this.config.periodType != null) {
                switch (this.config.periodType) {
                    case 'last_year': start = currDate.setFullYear(currDate.getFullYear() - (this.config.periodLength != null ? this.config.periodLength : 1));
                        break;
                    case 'last_month': start = currDate.setMonth(currDate.getMonth() - (this.config.periodLength != null ? this.config.periodLength : 1));
                        break;
                    case 'last_day': start = currDate.setDate(currDate.getDate() - (this.config.periodLength != null ? this.config.periodLength : 1));
                        break;
                    case 'last_hour': start = currDate.setHours(currDate.getHours() - (this.config.periodLength != null ? this.config.periodLength : 1));
                        break;
                }
            }
        }

        const opts = {
            id: this.timelineRootId,
            type: this.config.type != null ? this.config.type : "continuous",
            start: start != null ? start : null,
            end: end != null ? end : null,
            step: {
                unit: this.config.unit != null ? this.config.unit : "M",
                size: 100,
                breakpoint: 90,
                format: this.config.format != null ? this.config.format : "MMM-YYYY",
            },
            selector: {
                resizeable: true,
                type: this.config.selectorType != null ? this.config.selectorType : "interval",
                start: null,
                end: null,
            },
            tooltips: {
                format: this.config.format != null ? this.config.format : "D-MMM-YYYY",
                width: 100,
            },
            player: {
                loop: this.config.loop != null ? this.config.loop : true,
                speed: this.config.speed != null ? this.config.speed : 1000,
            },
            styles: {
                bgColor: this.config.background != null ? this.config.background : "rgba(0,0,0,0.5)",
                thumbColor: this.config.thumb != null ? this.config.thumb : "rgba(0,0,0,0.7)",
                channelColor: this.config.channel != null ? this.config.channel : "rgba(0,0,0,0.6)",
            },
            onChange: this._onChange
        };

        this.timeline = new Timeline(this.toolbarContainer, opts, this);
        $('#' + this.timelineRootId).hide();
    }

    _onChange(evt, ref) {
        let timelineLayers = ref._getTimelineLayers();

        timelineLayers.forEach(timelineLayer => {
            if (timelineLayer.type == 'layer') {
                if (timelineLayer.interpretation == 'WMS') {
                    ref.handleWmsLayerChange(evt, timelineLayer);
                } else if (timelineLayer.interpretation == 'image_tile') {
                    // cannot be implemented
                } else if (timelineLayer.interpretation == 'vector_tile') {
                    // cannot be implemented
                } else {
                    ref.handleWfsLayerChange(evt, timelineLayer);
                }

            } else if (timelineLayer.type == 'geoservice') {
                if (timelineLayer.serviceType == 'WMS') {
                    ref.handleWmsLayerChange(evt, timelineLayer);
                }
            }
        });
    }

    _getTimelineLayers() {
        return [];
    }

    _actionButtonClickHandler() {
        return () => {
            if (this.active) {
                this._hideToolbar();
            } else {
                this._showToolbar();
            }
        };
    }

    _hideToolbar() {
        $('.page-footer-item').css('margin-bottom', '0px');
        $('.page-content-wrapper').css('height', 'calc(100%)');
        this.active = false;
        $('#' + this.elementId).removeClass('selected');
        $('#' + this.timelineRootId).hide();
    }

    _showToolbar() {
        $('.page-footer-item').css('margin-bottom', '45px');
        $('.page-content-wrapper').css('height', 'calc(100% - 45px)');

        $('#' + this.elementId).addClass('selected');
        this.active = true;
        $('#' + this.timelineRootId).show();
    }

    _getToolbarTemplate() {
        return ``;
    }

    _getActionButtonTemplate() {
        let div = document.createElement('div');
        div.innerHTML = `<li>
                            <a class="btn map-menu-item" id="` + this.elementId + `" title="` + this._getTitle() + `">
                                <i class="` + this.action.Icon + `"></i>
                            </a>
                        </li>`;
        return div.firstChild;
    }

    _getTitle() {
        if (this.action.Title != null && this.action.Title != '') {
            return this.action.Title;
        }

        return this.resourcesHandler.get('SubType_' + this.action.SubType);
    }
}